
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"4","height":"7","viewBox":"0 0 4 7","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0.163097 0.964644L2.50823 3.5L0.163153 6.03536C-0.0535836 6.25529 -0.0544143 6.61272 0.161298 6.8337C0.377038 7.05473 0.727626 7.05549 0.944334 6.83561L3.8379 3.89959C4.05472 3.67892 4.05353 3.31981 3.83735 3.09987L0.944279 0.164385C0.727542 -0.055522 0.376955 -0.0547037 0.161242 0.166305C-0.0544696 0.387284 -0.0536389 0.744708 0.163097 0.964644Z"}})])
          )
        }
      }
    